// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"789":"5e840285d902859de411","793":"f6c95c9b10f9c8782fc3","845":"9a9425464d0f68359285","884":"4aad1fc4837670485aff","916":"2ff8b3a7a61e0ff0eeb0"}[chunkId] + ".js";
};